import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectMemberSaveFailedAction = {
	type: 'SUBJECT_MEMBER_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectMemberSaveFailedAction => ({
	type: 'SUBJECT_MEMBER_SAVE_FAILED',
	payload,
});
